import { useState, useRef } from "react";
import { Spin, Button } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import BarCodeComponentForRetail from "../../../lib/BarCodeComponentForRetail";
import { useWindowDimensions } from "../../../lib/useViewport";
import useSyncProgressStore from "../../../stores/useSyncProgressStore";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";
import { useHistory } from "react-router-dom";
import ScanIcon from "../../../assets/images/scanIcon.svg";
import FilterIcon from "../../../assets/images/filterNewICon.svg";
import RetailModals from "../../PointOfSale/Retail/RetailModals";
import ManagePreorder from "./ManagePreorder";
import RenderInput from "../../../lib/components/RenderInput";
import LoadingScreen from "../../PointOfSale/Retail/SuperMarket/LoadingScreen";
import POSLogo from "../../../assets/images/NewLogoCW.svg";
import leftLoading from "../../../assets/images/opo.gif";
import { clock } from "../../../utils/clock";
import { useEventBus } from "../../../lib/components/EventBusProvider";
import useAuthStore from "../../../stores/useAuthStore";
import useTransactionStore from "../../../stores/useTransactionStore";

// Extracted sub-components
import LockScreenView from "./LockScreen";
import ParkedBillView from "./ParkedBillView";
import CashManagementView from "./CashManagementView";
import SideMenuDrawer from "./SideMenuDrawer";
import CartSummary from "./CartSummary";
import QtyPricePanel from "./QtyPricePanel";
import PaymentPanel from "./PaymentPanel";
import HeaderBar from "./HeaderBar";
import CartMenuButtons from "./CartMenuButtons";
import ProductDetailPanel from "./ProductDetailPanel";
import CustomerSearchBar from "./CustomerSearchBar";
import CartTableSection from "./CartTableSection";
import ProductPanelsSection from "./ProductPanelsSection";
import { getCartColumns, parkedBillColumns, cashManagementColumns } from "./cartTableColumns";
import usePreorderHandlers from "./hooks/usePreorderHandlers";
import usePreorderEffects from "./hooks/usePreorderEffects";
import { GiftCardDrawer } from "../../PointOfSale/Retail/SuperMarket/modals";

const SupermarketPreorder = (props) => {
  const {
    showSaleType,
    setIsSaleTypeFlag,
    selectedSaleType,
    tillData,
    clearProductSearchResults,
    setProductSearchInput,
    productSearchInput,
    setOpen,
    setInputName,
    setIsInputFocused,
    productSearchInputRef,
    onBarcodeInput,
    setIsProductsFilter,
    setFilterDrawer,
    documentTypes,
    selectedDocumentType,
    setSelectedDocumentType,
    setShowDocumentPopup,
    setNotesValue,
    selectedProductInCart,
    setSelectedProductInCart,
    selectProductInCart,
    showPaymentMethods,
    setShowPaymentMethods,
    selectedRowKeys,
    deleteProduct,
    setCustomMixItems,
    setGroupQty,
    setSelectedProductForNotes,
    setOpenSalesRep,
    realPrice,
    setRealPrice,
    setFirstInputValue,
    setSelectedCustomMix,
    setExistingGroupItems,
    setOverPayedAmount,
    overPayedAmount,
    amount,
    setAmount,
    setQtyNumberFlag,
    setStockList,
    stockList,
    keyboard,
    clearSelectedProductInCart,
    verifyStock,
    openDisplayParkedBillModal,
    filterDrawer,
    couponModalVisible,
    displayAddNewCustomer,
    validateGiftCard,
    displayCustomerSearch,
    displayEditOldCustomer,
    giftCardFlag,
    isGiftCardFlag,
    manualDiscountModalVisible,
    loyalityOtpModalVisible,
    cart,
    setDisplayCustomerSearch,
    setCloseCustomerFlag,
    setEditFlag,
    removeCutomer,
    showAddNewCustomerFields,
    showEditOldCustomerFields,
    manualDiscountForm,
    setManualDiscountInput,
    setSelectedManualDiscountTypeValue,
    setManualDiscountModalVisible,
    setIsGiftCardFlag,
    isNewGiftCardFlag,
    setIsNewGiftCardFlag,
    giftCardMode,
    setGiftCardMode,
    setAddToBagFlag,
    setGiftCardType,
    searchOrderHistory,
    modifyProductList,
    onChangeTotalQuantity,
    enterTotalQty,
    handleTotalQty,
    decreaseProductQty,
    increaseProductQty,
    handleRealPrice,
    enterRealPrice,
    showPayments,
    setShowPayments,
    setNumb,
    setIsCardPaymentFlag,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    paymentModalInputRef,
    processOrder,
    paymentCardRef,
    filteredPaymentMethods,
    isShowingAll,
    onChangeAmount,
    requestPayment,
    setDenaminationsKeyboard,
    denaminationsKeyboard,
    currenciesData,
    handleCashPayment,
    handleAmount,
    giftCardData,
    setGiftCardData,
    handleLoyaltyPayment,
    setCart,
    getFilteredPaymentMethods,
    setStartIndex,
    startIndex,
    setSelectedKeys,
    filterdParkedList,
    showOrderHistory,
    selectedSaleTypeData,
    checkIsManualWeight,
    setIsSearchProducts,
    getMoreProducts,
    isProductsFilter,
    getSearchedProducts,
    productListCardRef,
    isProductsVisible,
    setIsProductsVisible,
    pickProduct,
    setKeyboardType,
    keyboardType,
    productsData,
    setLayoutName,
    hasShownCustomerModalRef,
    orderType,
    deleteCart,
    documentSequence,
    setDocumnetSequence,
    setAddCashFlag,
    setCashAddInFlag,
    paymentModal,
    addCashFlag,
    setParkedBillSearchInput,
    searchParkedBill,
    parkedBillSearchInput,
    selectedKeys,
    selectParkedBill,
    upsertPOSLog,
    discardParkedBill,
    options,
    setOptions,
    searchInputRef,
    activeInput,
    setActiveInput,
    qtyInputRef,
    customMixItems,
    existingGroupItems,
    selectedCustomMix,
    setOrderType,
    groupQty,
    posSaleTypes,
    setPosSaleTypes,
    setCurrenciesData,
    deleteReceipt,
    calendarVisible,
    setCalendarVisible,
    selectedDate,
    setSelectedDate,
    closeProductPanel,
    isQtyUpdate,
    setProductStock,
    loading,
    setLoading,
    cardPaymnetStatus,
    setCardPaymnetStatus,
    cardPaymnetStatusPLB,
    setCardPaymnetStatusPLB,
    metaDataRef,
    setTempCart,
    tempCart,
    showCompleteSaleStock,
    setShowCompleteSaleStock,
    completeSaleStockData,
    setCompleteSaleStockData,
    clearReturnCartData,
    walletFunc,
    PaymentMethods,
    syncLoad,
    setSyncLoad,
    setFilterdParkedList,
    mapParkedList,
    notesPopup,
    setNotesPopup,
    debounceRef,
    enterRef,
    retailCustomerFields,
    convertMetaDataToKeyValue,
    customerForm,
    autoEnablePanCustomer,
    autoEnableNriBilling,
    setViewCustomerValues,
    setSelectedEditOldCustomer,
    setDisplayEditOldCustomer,
    setDisplayAddNewCustomer,
    setIsViewMode,
    syncOrders,
  } = props;
  const { percent, promotionPercentage, productPercentage, productCategoryPercentage, resetProgress } = useSyncProgressStore();
  const { dispatchEvent, dispatchItemSelection } = useEventBus();
  const { width } = useWindowDimensions();
  const history = useHistory();
  const colorVariable = process.env.REACT_APP_POSBACKGROUND_COLOR;
  const domainURL = process.env.REACT_APP_domain;
  const [tillLink, setTillLink] = useState(false);
  const productSearchRef = useRef(null);
  const productPanelSearchRef = useRef(null);
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  const themeJSON = (() => {
    try {
      const raw = posConfig?.themeJSON;
      if (!raw || raw === "N") return {};
      const obj = typeof raw === "string" ? JSON.parse(raw) : raw;
      return obj?.layout4 || {};
    } catch {
      return {};
    }
  })();
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [showCustomMix, setShowCustomMix] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isLocked, setIsLocked] = useState(false);
  const userData = useAuthStore((s) => s.userData);
  const [isSectionVisible, setIsSectionVisible] = useState(false);
  const [showInputFields, setShowInputFields] = useState(false);
  const [dateRange, setDateRange] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [productItems, setProductItems] = useState([]);
  const [showPreOrders, setShowPreOrders] = useState(false);
  const [productsDisplay, setProductDisplay] = useState("super-market");
  const [productsList, setProductsList] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [retrunSearchType, setReturnSearchType] = useState("orderNo");
  const [isCashMangement, setIsCashManagement] = useState(false);
  const [cashManagementData, setCashManagementData] = useState(false);
  const [keyValue, setKeyValue] = useState("0");
  const [isParkedBill, setIsparkedBill] = useState(false);
  const [tableValue, setTableValue] = useState("POS");
  const [parkedBill, setParkedBill] = useState();
  const [productMap, setProductMap] = useState({});
  const [groupName, setGroupName] = useState("Custom Mix");
  const [productArray, setProductArray] = useState();
  const [calendarVisibleMap, setCalendarVisibleMap] = useState({});
  const [clock1, setClock1] = useState(clock());
  const selectBagRef = useRef(null);
  const realPriceRef = useRef(null);
  let parkedBillRef = useRef();
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const customerId = tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId;
  const tillAccessData = tillData?.tillAccess;
  const CWHardwareController = tillData.tillAccess.cwrTill.printTemplate.cwController === "Y" ? true : false;

  // Extracted handlers
  const {
    errorMessage,
    handleLogin,
    onChangeParkedBill,
    handleExpandPerkedData: _handleExpandPerkedData,
    retrieveParkedData,
    discardMessage,
    handleCancel,
    deleteProductModal,
    handleDeletePayment,
    handleKeyvalue,
    showConfirm,
    showMoreItems,
    showPreviousItems,
    handleViewStockClick,
    onChangeInput,
    handleDateSelect,
    toggleCalendar,
    handleSelectProduct,
    modulo,
  } = usePreorderHandlers({
    cart,
    setCart,
    tillData,
    posConfig,
    amount,
    setAmount,
    overPayedAmount,
    setOverPayedAmount,
    pricePrecision,
    giftCardData,
    setGiftCardData,
    handleLoyaltyPayment,
    documentSequence,
    setDocumnetSequence,
    orderType,
    deleteCart,
    getFilteredPaymentMethods,
    setShowPayments,
    showPayments,
    startIndex,
    setStartIndex,
    setSelectedKeys,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    setSelectedDocumentType,
    hasShownCustomerModalRef,
    keyboard,
    searchInputRef,
    debounceRef,
    enterRef,
    productSearchInput,
    setProductSearchInput,
    setCustomMixItems,
    setGroupQty,
    setActiveInput,
    setShowInputFields,
    selectParkedBill,
    openDisplayParkedBillModal,
    discardParkedBill,
    setParkedBillSearchInput,
    filterdParkedList,
    setFilterdParkedList,
    mapParkedList,
    showOrderHistory,
    setSyncLoad,
    resetProgress,
    selectedSaleTypeData,
    selectedProductInCart,
    setStockList,
    setOptions,
    setProductMap,
    isOnline,
    isLocked,
    dispatchEvent,
    setKeyValue,
    setSelectedProductForNotes,
    setCalendarVisible,
    selectedDate,
    setSelectedDate,
    setCalendarVisibleMap,
    setIsInputFocused,
    syncOrders,
  });

  // Wrap handleExpandPerkedData to pass local state
  const handleExpandPerkedData = (record) => _handleExpandPerkedData(record, expandedRowKeys, setExpandedRowKeys);

  const removeProductModal = (record) => {
    setShowCustomMix(false);
    deleteProduct(record);
  };

  // ─── Effects (extracted) ───
  usePreorderEffects({
    isLocked,
    setIsOnline,
    amount,
    selectedPaymentMethod,
    showPayments,
    setSelectedPaymentMethod,
    cardPaymnetStatusPLB,
    setCardPaymnetStatusPLB,
    setCart,
    setProductSearchInput,
    keyboard,
    isParkedBill,
    parkedBillRef,
    filterdParkedList,
    addCashFlag,
    paymentModal,
    setCashManagementData,
    setKeyValue,
    cart,
    handleDeletePayment,
  });

  const formattedDateTime = `${currentDateTime.toLocaleTimeString()} | ${currentDateTime.toLocaleDateString("en-US", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  })}`;

  // Barcode flag: enabled when no modals/inputs are active
  const inputFocused = ["sm-customer-search", "sm-amount-input", "sm-total-amount-input"].some((id) => document.getElementById(id) === document.activeElement);
  const approvalFlag = useTransactionStore.getState().approvalFlag || "1";
  const barcodeFlag =
    !couponModalVisible &&
    !displayAddNewCustomer &&
    !validateGiftCard &&
    !displayCustomerSearch &&
    !displayEditOldCustomer &&
    !giftCardFlag &&
    !filterDrawer &&
    !isGiftCardFlag &&
    !manualDiscountModalVisible &&
    !loyalityOtpModalVisible &&
    !inputFocused &&
    !showCustomMix &&
    approvalFlag === "1";

  const cartItems = (cart?.items || []).filter((item) => item.weight !== 0);
  const hasExpandableRows = cartItems.some((item) => item.children && item.children.length > 0);

  // Build cart table columns via extracted helper
  const cartColumns = getCartColumns({
    posConfig,
    cart,
    pricePrecision,
    currenciesList,
    selectProductInCart,
    selectedRowKeys,
    setShowPaymentMethods,
    clearSelectedProductInCart,
    removeProductModal,
    setIsInputFocused,
    setShowInputFields,
    setCustomMixItems,
    setGroupQty,
    setActiveInput,
    searchInputRef,
    setNotesPopup,
    setNotesValue,
    setSelectedProductForNotes,
    setOpenSalesRep,
  });

  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 40, marginTop: "18vh", color: "#2F3856" }} spin />} spinning={loading}>
      <>
        <div style={{ backgroundColor: colorVariable ? colorVariable : "#f3f4f9", height: "100vh", width: "100%" }}>
          {showPreOrders ? (
            <ManagePreorder
              {...props}
              isLocked={isLocked}
              setIsLocked={setIsLocked}
              isSectionVisible={isSectionVisible}
              setIsSectionVisible={setIsSectionVisible}
              showPreOrders={showPreOrders}
              setShowPreOrders={setShowPreOrders}
              dateRange={dateRange}
              setDateRange={setDateRange}
              expandedRowKeys={expandedRowKeys}
              setExpandedRowKeys={setExpandedRowKeys}
              checkedKeys={checkedKeys}
              setCheckedKeys={setCheckedKeys}
              retrunSearchType={retrunSearchType}
              setReturnSearchType={setReturnSearchType}
            />
          ) : isLocked ? (
            <LockScreenView isOnline={isOnline} handleLogin={handleLogin} />
          ) : isParkedBill ? (
            <ParkedBillView
              themeJSON={themeJSON}
              pricePrecision={pricePrecision}
              parkedBillRef={parkedBillRef}
              parkedBillSearchInput={parkedBillSearchInput}
              onChangeParkedBill={onChangeParkedBill}
              searchParkedBill={searchParkedBill}
              setIsparkedBill={setIsparkedBill}
              setIsInputFocused={setIsInputFocused}
              setParkedBillSearchInput={setParkedBillSearchInput}
              setLayoutName={setLayoutName}
              setInputName={setInputName}
              setOpen={setOpen}
              keyboard={keyboard}
              filterdParkedList={filterdParkedList}
              selectedKeys={selectedKeys}
              expandedRowKeys={expandedRowKeys}
              handleExpandPerkedData={handleExpandPerkedData}
              setTableValue={setTableValue}
              retrieveParkedData={retrieveParkedData}
              upsertPOSLog={upsertPOSLog}
              cart={cart}
              setParkedBill={setParkedBill}
              discardMessage={discardMessage}
              columns={parkedBillColumns}
              tillData={tillData}
              colorVariable={colorVariable}
            />
          ) : isCashMangement ? (
            <CashManagementView
              {...props}
              themeJSON={themeJSON}
              colorVariable={colorVariable}
              setIsCashManagement={setIsCashManagement}
              setAddCashFlag={setAddCashFlag}
              setCashAddInFlag={setCashAddInFlag}
              cashManagementData={cashManagementData}
              cashManagementColumn={cashManagementColumns}
              selectBagRef={selectBagRef}
            />
          ) : syncLoad ? (
            <>
              <LoadingScreen
                colorVariable={colorVariable}
                POSLogo={POSLogo}
                formattedDateTime={formattedDateTime}
                clock1={clock1}
                leftLoading={leftLoading}
                percent={percent}
                productCategoryPercentage={productCategoryPercentage}
                productPercentage={productPercentage}
                promotionPercentage={promotionPercentage}
              />
            </>
          ) : (
            <>
              {/* Top header bar */}
              <HeaderBar
                colorVariable={colorVariable}
                themeJSON={themeJSON}
                posConfig={posConfig}
                formattedDateTime={formattedDateTime}
                userData={userData}
                isOnline={isOnline}
                showSaleType={showSaleType}
                selectedSaleType={selectedSaleType}
                cart={cart}
                setTillLink={setTillLink}
                setIsSaleTypeFlag={setIsSaleTypeFlag}
                setIsLocked={setIsLocked}
                setShowCustomMix={setShowCustomMix}
                deleteReceipt={deleteReceipt}
                history={history}
                errorMessage={errorMessage}
              />

              {barcodeFlag && <BarCodeComponentForRetail onScan={onBarcodeInput} setProductSearchInput={setProductSearchInput} productSearchInput={productSearchInput} />}

              <div style={{ display: "flex", height: "91vh" }}>
                {/* Left panel */}
                <div style={{ width: "63.9%" }}>
                  <div style={{ display: "flex", width: "100%", padding: "0 0 0 1.7%" }}>
                    <div style={{ width: "93%" }}>
                      <RenderInput
                        posConfig={posConfig}
                        options={options}
                        productMap={productMap}
                        pickProduct={pickProduct}
                        productSearchInput={productSearchInput}
                        setProductSearchInput={setProductSearchInput}
                        setOptions={setOptions}
                        keyboard={keyboard}
                        filterDrawer={filterDrawer}
                        searchInputRef={searchInputRef}
                        clearProductSearchResults={clearProductSearchResults}
                        onChangeInput={onChangeInput}
                        setOpen={setOpen}
                        setInputName={setInputName}
                        setIsInputFocused={setIsInputFocused}
                        onBarcodeInput={onBarcodeInput}
                        productSearchInputRef={productSearchInputRef}
                        debounceRef={debounceRef}
                        enterRef={enterRef}
                      />
                    </div>
                    <Button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        // width: "4.5%",
                        margin: "0 0.2vw 0 0.8vw",
                        borderRadius: "7px",
                        height: "inherit",
                        borderColor: "#fff",
                      }}
                      onClick={() => setIsProductsFilter(true)}
                    >
                      <img src={ScanIcon} style={{ height: "2.7vh" }} />
                    </Button>
                    <Button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        // width: "4.5%",
                        margin: "0 1vw 0 0.5vw",
                        borderRadius: "7px",
                        height: "inherit",
                        borderColor: "#fff",
                      }}
                      id="sm-product-drawer"
                      onClick={() => setFilterDrawer(true)}
                    >
                      <img src={FilterIcon} style={{ height: "2.7vh" }} />
                    </Button>
                  </div>

                  <CartTableSection
                    cart={cart}
                    posConfig={posConfig}
                    themeJSON={themeJSON}
                    pricePrecision={pricePrecision}
                    cartItems={cartItems}
                    cartColumns={cartColumns}
                    hasExpandableRows={hasExpandableRows}
                    selectedProductInCart={selectedProductInCart}
                    calendarVisible={calendarVisible}
                    setCalendarVisible={setCalendarVisible}
                    selectedDate={selectedDate}
                    handleDateSelect={handleDateSelect}
                    setNotesPopup={setNotesPopup}
                    setNotesValue={setNotesValue}
                    setIsInputFocused={setIsInputFocused}
                    setShowInputFields={setShowInputFields}
                    setRealPrice={setRealPrice}
                    setFirstInputValue={setFirstInputValue}
                    setSelectedCustomMix={setSelectedCustomMix}
                    setCustomMixItems={setCustomMixItems}
                    setGroupQty={setGroupQty}
                    setExistingGroupItems={setExistingGroupItems}
                    setOverPayedAmount={setOverPayedAmount}
                    setAmount={setAmount}
                    selectProductInCart={selectProductInCart}
                    setQtyNumberFlag={setQtyNumberFlag}
                    setShowPaymentMethods={setShowPaymentMethods}
                    setSelectedProductInCart={setSelectedProductInCart}
                    setStockList={setStockList}
                    qtyInputRef={qtyInputRef}
                  />

                  {/* Cart summary (subtotals + total/hold/cancel) */}
                  <CartSummary
                    cart={cart}
                    pricePrecision={pricePrecision}
                    currenciesList={currenciesList}
                    themeJSON={themeJSON}
                    openDisplayParkedBillModal={openDisplayParkedBillModal}
                    deleteProductModal={deleteProductModal}
                    verifyStock={verifyStock}
                    setCart={setCart}
                    amount={amount}
                  />
                </div>

                {/* Right panel */}
                <div style={{ width: "35.6%", padding: "0% 0% 0 0.4%", borderRadius: "10px", paddingBottom: "0", height: "89vh", marginRight: "1%" }}>
                  {/* Customer search / info */}
                  <CustomerSearchBar
                    tillData={tillData}
                    cart={cart}
                    customerId={customerId}
                    retailCustomerFields={retailCustomerFields}
                    convertMetaDataToKeyValue={convertMetaDataToKeyValue}
                    customerForm={customerForm}
                    autoEnablePanCustomer={autoEnablePanCustomer}
                    autoEnableNriBilling={autoEnableNriBilling}
                    setViewCustomerValues={setViewCustomerValues}
                    setSelectedEditOldCustomer={setSelectedEditOldCustomer}
                    setDisplayEditOldCustomer={setDisplayEditOldCustomer}
                    setDisplayAddNewCustomer={setDisplayAddNewCustomer}
                    setIsViewMode={setIsViewMode}
                    setDisplayCustomerSearch={setDisplayCustomerSearch}
                    setCloseCustomerFlag={setCloseCustomerFlag}
                    showEditOldCustomerFields={showEditOldCustomerFields}
                    setEditFlag={setEditFlag}
                    removeCutomer={removeCutomer}
                    showAddNewCustomerFields={showAddNewCustomerFields}
                  />

                  <div style={{ display: "flex", fontSize: "1vw" }}>
                    {/* Left icon column (menu buttons) */}
                    <CartMenuButtons
                      themeJSON={themeJSON}
                      posConfig={posConfig}
                      tillAccessData={tillAccessData}
                      tillData={tillData}
                      cart={cart}
                      isOnline={isOnline}
                      selectedProductInCart={selectedProductInCart}
                      pricePrecision={pricePrecision}
                      handleKeyvalue={handleKeyvalue}
                      setIsparkedBill={setIsparkedBill}
                      setShowPreOrders={setShowPreOrders}
                      setAddToBagFlag={setAddToBagFlag}
                      setOpenSalesRep={setOpenSalesRep}
                      setManualDiscountInput={setManualDiscountInput}
                      setSelectedManualDiscountTypeValue={setSelectedManualDiscountTypeValue}
                      manualDiscountForm={manualDiscountForm}
                      setManualDiscountModalVisible={setManualDiscountModalVisible}
                      setProductSearchInput={setProductSearchInput}
                      openDisplayParkedBillModal={openDisplayParkedBillModal}
                      clearReturnCartData={clearReturnCartData}
                      searchOrderHistory={searchOrderHistory}
                      setDateRange={setDateRange}
                      errorMessage={errorMessage}
                    />

                    {/* Qty/price panel (hidden when payment methods shown) */}
                    <div style={{ width: "81.5%", paddingTop: "3%", display: showPaymentMethods && "none" }}>
                      {/* Selected product card */}
                      <ProductDetailPanel
                        selectedProductInCart={selectedProductInCart}
                        stockList={stockList}
                        setStockList={setStockList}
                        pricePrecision={pricePrecision}
                        currenciesList={currenciesList}
                        posConfig={posConfig}
                        handleViewStockClick={handleViewStockClick}
                        modifyProductList={modifyProductList}
                      />

                      {/* Qty/Price keypad */}
                      <QtyPricePanel
                        showInputFields={showInputFields}
                        selectedProductInCart={selectedProductInCart}
                        qtyInputRef={qtyInputRef}
                        realPriceRef={realPriceRef}
                        realPrice={realPrice}
                        setRealPrice={setRealPrice}
                        cart={cart}
                        onChangeTotalQuantity={onChangeTotalQuantity}
                        setIsInputFocused={setIsInputFocused}
                        enterTotalQty={enterTotalQty}
                        handleTotalQty={handleTotalQty}
                        decreaseProductQty={decreaseProductQty}
                        increaseProductQty={increaseProductQty}
                        handleRealPrice={handleRealPrice}
                        enterRealPrice={enterRealPrice}
                      />
                    </div>

                    {/* Payment panel (shown when payment methods toggled) */}
                    <div style={{ width: "81.5%", paddingTop: "3%", display: !showPaymentMethods && "none" }}>
                      <PaymentPanel
                        cart={cart}
                        setCart={setCart}
                        tillData={tillData}
                        posConfig={posConfig}
                        pricePrecision={pricePrecision}
                        currenciesList={currenciesList}
                        themeJSON={themeJSON}
                        showPayments={showPayments}
                        filteredPaymentMethods={filteredPaymentMethods}
                        isShowingAll={isShowingAll}
                        showPreviousItems={showPreviousItems}
                        showMoreItems={showMoreItems}
                        selectedPaymentMethod={selectedPaymentMethod}
                        setSelectedPaymentMethod={setSelectedPaymentMethod}
                        amount={amount}
                        setAmount={setAmount}
                        overPayedAmount={overPayedAmount}
                        setOverPayedAmount={setOverPayedAmount}
                        setNumb={setNumb}
                        setIsCardPaymentFlag={setIsCardPaymentFlag}
                        paymentModalInputRef={paymentModalInputRef}
                        paymentCardRef={paymentCardRef}
                        onChangeAmount={onChangeAmount}
                        setIsInputFocused={setIsInputFocused}
                        requestPayment={requestPayment}
                        setDenaminationsKeyboard={setDenaminationsKeyboard}
                        denaminationsKeyboard={denaminationsKeyboard}
                        currenciesData={currenciesData}
                        handleCashPayment={handleCashPayment}
                        handleAmount={handleAmount}
                        handleDeletePayment={handleDeletePayment}
                        processOrder={processOrder}
                        walletFunc={walletFunc}
                        showConfirm={showConfirm}
                        modulo={modulo}
                        CWHardwareController={CWHardwareController}
                        width={width}
                        setIsNewGiftCardFlag={setIsNewGiftCardFlag}
                        setGiftCardMode={setGiftCardMode}
                      />
                    </div>
                  </div>
                </div>
                <RetailModals {...props} selectBagRef={selectBagRef} />

                {/* Gift Card Drawer for Pre-Order payment flow (BUG-1099) */}
                {isNewGiftCardFlag && (
                  <GiftCardDrawer
                    isNewGiftCardFlag={isNewGiftCardFlag}
                    setIsNewGiftCardFlag={setIsNewGiftCardFlag}
                    cart={cart}
                    posConfig={posConfig}
                    currenciesList={currenciesList}
                    currenciesData={currenciesData}
                    showPayments={showPayments}
                    setShowPayments={setShowPayments}
                    setStartIndex={setStartIndex}
                    selectedPaymentMethod={selectedPaymentMethod}
                    setSelectedPaymentMethod={setSelectedPaymentMethod}
                    requestPayment={requestPayment}
                    getFilteredPaymentMethods={getFilteredPaymentMethods}
                    themeJSON={themeJSON}
                    giftCardMode={giftCardMode}
                  />
                )}
              </div>
            </>
          )}
        </div>

        {/* Side menu drawer */}
        <SideMenuDrawer
          tillLink={tillLink}
          setTillLink={setTillLink}
          setActiveInput={setActiveInput}
          setSelectedDocumentType={setSelectedDocumentType}
          searchInputRef={searchInputRef}
          posConfig={posConfig}
          isOnline={isOnline}
          cart={cart}
          tillData={tillData}
          setShowPreOrders={setShowPreOrders}
          searchOrderHistory={searchOrderHistory}
          setDateRange={setDateRange}
          handleCancel={handleCancel}
          domainURL={domainURL}
        />

        {/* Product panels (drawer + inline + grouped products) */}
        <ProductPanelsSection
          checkIsManualWeight={checkIsManualWeight}
          setIsSearchProducts={setIsSearchProducts}
          getMoreProducts={getMoreProducts}
          productItems={productItems}
          setProductItems={setProductItems}
          selectProductInCart={selectProductInCart}
          setProductArray={setProductArray}
          isProductsFilter={isProductsFilter}
          getSearchedProducts={getSearchedProducts}
          productListCardRef={productListCardRef}
          productsDisplay={productsDisplay}
          isProductsVisible={isProductsVisible}
          setIsProductsVisible={setIsProductsVisible}
          pickProduct={pickProduct}
          filterDrawer={filterDrawer}
          setFilterDrawer={setFilterDrawer}
          productSearchInput={productSearchInput}
          setProductSearchInput={setProductSearchInput}
          setOpen={setOpen}
          keyboardType={keyboardType}
          setKeyboardType={setKeyboardType}
          productSearchInputRef={productSearchInputRef}
          clearProductSearchResults={clearProductSearchResults}
          productsData={productsData}
          productSearchRef={productSearchRef}
          handleSelectProduct={handleSelectProduct}
          productsList={productsList}
          setProductsList={setProductsList}
          setLayoutName={setLayoutName}
          productPanelSearchRef={productPanelSearchRef}
          setInputName={setInputName}
          keyboard={keyboard}
          searchInputRef={searchInputRef}
          setCart={setCart}
          closeProductPanel={closeProductPanel}
          isQtyUpdate={isQtyUpdate}
          showCustomMix={showCustomMix}
          setShowCustomMix={setShowCustomMix}
          cart={cart}
          customMixItems={customMixItems}
          setCustomMixItems={setCustomMixItems}
          groupName={groupName}
          setGroupName={setGroupName}
          groupQty={groupQty}
          setGroupQty={setGroupQty}
          existingGroupItems={existingGroupItems}
          setExistingGroupItems={setExistingGroupItems}
          selectedCustomMix={selectedCustomMix}
          setSelectedCustomMix={setSelectedCustomMix}
          orderType={orderType}
          setOrderType={setOrderType}
          posSaleTypes={posSaleTypes}
          setPosSaleTypes={setPosSaleTypes}
          currenciesData={currenciesData}
          setCurrenciesData={setCurrenciesData}
          setActiveInput={setActiveInput}
          setProductStock={setProductStock}
          setShowCompleteSaleStock={setShowCompleteSaleStock}
          setCompleteSaleStockData={setCompleteSaleStockData}
        />
      </>
    </Spin>
  );
};

export default SupermarketPreorder;
